import React, { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface VersionBadgeProps {
  version?: number | string;
  className?: string;
  text?: string;
  icon?: React.ReactNode;
  onHoverChange?: (isHovered: boolean) => void;
}

export function VersionBadge({
  version,
  className,
  text,
  icon,
  onHoverChange,
}: VersionBadgeProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    onHoverChange?.(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    onHoverChange?.(false);
  };

  return (
    <Badge
      variant="outline"
      className={cn(
        "h-[24px] transition-all duration-300 ease-in-out overflow-hidden whitespace-nowrap",
        className
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className="flex items-center">
        {icon && icon}
        {version && <span>v{version}</span>}
        <span
          className={cn(
            "transition-all duration-300 ease-in-out hover:max-w-24",
            isHovered
              ? "ml-1 opacity-100 transition-opacity duration-300"
              : "opacity-0 max-w-0"
          )}
        >
          {text}
        </span>
      </span>
    </Badge>
  );
}
